import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/JS.mp4'
import _imports_1 from '@/assets/en-subtitle.vtt'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col s12 mainPlayer" }
const _hoisted_3 = { class: "col s12 playerContainer" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "video/mp4"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("track", {
  src: _imports_1,
  kind: "captions",
  srclang: "en",
  label: "english_captions"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "col s12 buttonsPlayer start"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "col s12 buttonsPlayer stop"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col s8 showScenne" }
const _hoisted_14 = { class: "col s4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScoreBar = _resolveComponent("ScoreBar")!
  const _component_StagePlayer = _resolveComponent("StagePlayer")!
  const _component_SceneList = _resolveComponent("SceneList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ScoreBar, { class: "col s12" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("video", {
          id: "Player",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.showStage && _ctx.startPlayer()))
        }, _hoisted_7),
        _createElementVNode("div", {
          class: "col s12 centralPlayer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (!_ctx.showStage && _ctx.startPlayer()))
        }, [
          (!_ctx.runPlayer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: require(`@/assets/play-button.png`),
                  alt: "Play"
                }, null, 8, _hoisted_9)
              ]))
            : _createCommentVNode("", true),
          (_ctx.runPlayer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: require(`@/assets/pause-button.png`),
                  alt: "Pause"
                }, null, 8, _hoisted_11)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showStage)
          ? (_openBlock(), _createBlock(_component_StagePlayer, {
              key: 0,
              class: "col s12 Stage"
            }))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_SceneList, { class: "col s12 scenePanel" }, null, 512), [
          [_vShow, _ctx.scennesPanel]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("p", {
          class: _normalizeClass({ inActiveText: _ctx.showStage }),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.showStage && _ctx.showScenes()))
        }, "Pokaż sceny", 2)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", {
          role: "img",
          title: "Wyłącz/włącz dzwięk",
          class: "navi buttonSound sound",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mute($event)))
        }),
        _createElementVNode("div", {
          role: "img",
          title: "Napisy",
          class: "navi sub subOff",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.subtitleEvent($event)))
        }),
        _createElementVNode("div", {
          role: "img",
          title: "Powiększ/zmniejsz okno",
          class: "navi size maximalize",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.size($event)))
        })
      ])
    ])
  ]))
}